function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5297 15.9301C21.3697 15.6601 20.9197 15.2401 19.7997 15.4401C19.1797 15.5501 18.5497 15.6001 17.9197 15.5701C15.5897 15.4701 13.4797 14.4001 12.0097 12.7501C10.7097 11.3001 9.90971 9.41012 9.89971 7.37012C9.89971 6.23012 10.1197 5.13012 10.5697 4.09012C11.0097 3.08012 10.6997 2.55012 10.4797 2.33012C10.2497 2.10012 9.70971 1.78012 8.64971 2.22012C4.55971 3.94012 2.02971 8.04012 2.32971 12.4301C2.62971 16.5601 5.52971 20.0901 9.36971 21.4201C10.2897 21.7401 11.2597 21.9301 12.2597 21.9701C12.4197 21.9801 12.5797 21.9901 12.7397 21.9901C16.0897 21.9901 19.2297 20.4101 21.2097 17.7201C21.8797 16.7901 21.6997 16.2001 21.5297 15.9301Z",
  fill: "white"
});

var SvgIconMoonDark = function SvgIconMoonDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconMoonDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_moon_dark.57a14e03.svg";
export { ForwardRef as ReactComponent };